import React from "react";

class CssLoader extends React.Component{
    render(){
        return(
        <link rel='stylesheet' type='text/css' href={this.props.css }/>
        )
    }
}

export default CssLoader;